import { NOT_AVAILABLE } from 'constants/text';
var InvoiceStatus;
(function (InvoiceStatus) {
  InvoiceStatus["Pending"] = "pending";
  InvoiceStatus["InternalDebtCollection"] = "internal_debt_collection";
  InvoiceStatus["ExternalDebtCollection"] = "external_debt_collection";
  InvoiceStatus["Paid"] = "paid";
  InvoiceStatus["PaymentRequested"] = "payment_requested";
  InvoiceStatus["PaymentFailed"] = "payment_failed";
  InvoiceStatus["Cancelled"] = "cancelled";
  InvoiceStatus["Credited"] = "credited";
  InvoiceStatus["PaymentRevoked"] = "payment_revoked";
  InvoiceStatus["PaymentReminderSent"] = "payment_reminder_sent";
  InvoiceStatus["ClosedByDebtCollector"] = "closed_by_debt_collector";
  InvoiceStatus["CreditRejected"] = "credit_rejected";
  InvoiceStatus["CreditNote"] = "credit_note";
  InvoiceStatus["PaidByBalance"] = "paid_by_balance";
  InvoiceStatus["Remittance"] = "remittance";
  InvoiceStatus["Preparing"] = "preparing";
  InvoiceStatus["PreparingDistribution"] = "preparing_distribution";
  InvoiceStatus["SentToDistribution"] = "sent_to_distribution";
  InvoiceStatus["AwaitingDelivery"] = "awaiting_delivery";
  InvoiceStatus["Initial"] = "initial";
  InvoiceStatus["ValidationError"] = "validation_error";
  InvoiceStatus["PaymentRegistered"] = "payment_registered";
})(InvoiceStatus || (InvoiceStatus = {}));
const getInvoiceTranslationString = status => {
  if (!status) return NOT_AVAILABLE;
  return InvoiceStatus[status];
};
export default getInvoiceTranslationString;